// import { Suspense } from "react";
import styles from "./Instalment.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import AmenitySection from "../AmenitiesSection/components/AmenitySection";
import CustomAccordionItem from "./components/CustomAccordianItem";
import AccordionV2 from "@Components/Accordian";
import PropertyDetailsModal from "../PropertyDetailsModal";
import CustomModeOfPayment from "./components/CustomModeOfPayment";
import InstalmentFilterGroup from "./components/InstalmentFilterGroup";
import { getInstallmentPlansByGuarantorType } from "./utils";
import TabSection from "./components/InstalmentTabSection";
import wrapperHOC from "@Utils/wrapperHOC";
import Button from "@Components/Button";
import BillsIncludedModal from "../AmenitiesSection/components/BillsIncludedModal";
import {
  getPricingCurrency,
  getPricingDuration,
} from "@Pages/PropertyPage/components/RoomTypeSection/utils";
import { useSelector, shallowEqual } from "react-redux";
import { AppState } from "@Store/index";
import config from "@Config/index";
//

interface MobileInstalmentSectionProps {
  filteredData: any[];
  sortedData: any[];
  showModal: boolean;
  handleModalClose: () => void;
  selectedDuration: string;
  setSelectedDuration: (duration: string) => void;
  selectedYear: string;
  setSelectedYear: (year: string) => void;
  filtersData: {
    duration: string[];
    year: string[];
  };
  installmentPlans: any[];
  isModal: boolean;
  t: (key: string) => string;
  tabdata: any;
  setActiveTab: (tab: string) => void;
  activeTab: string;
  isDesktop: boolean;
  hasInstallmentPlans?: boolean;
  handleBillsModalOpen: () => void;
  handleBillsModalClose: () => void;
  showBillsModal: boolean;
  prefixContent: any;
  suffixContent: any;
  amenities: any[];
  totalCalculatedPrice: number;
  allAmenitiesHaveNAPrices: boolean;
  hasEstimatedItems: boolean;
}

const MobileInstalmentSection = ({
  filteredData,
  sortedData,
  showModal,
  handleModalClose,
  selectedDuration,
  setSelectedDuration,
  selectedYear,
  setSelectedYear,
  filtersData,
  installmentPlans,
  isModal,
  t,
  tabdata,
  setActiveTab,
  activeTab,
  isDesktop,
  hasInstallmentPlans = false,
  handleBillsModalOpen,
  handleBillsModalClose,
  showBillsModal,
  prefixContent,
  suffixContent,
  amenities = [],
  totalCalculatedPrice = 0,
  allAmenitiesHaveNAPrices = false,
  hasEstimatedItems = false,
}: MobileInstalmentSectionProps) => {
  const { inventoryCurrency, inventoryLocation, inventoryPricingDuration } = useSelector(
    ({ propertyPageData }: AppState) => ({
      inventoryCurrency: propertyPageData?.data?.pricing?.currency,
      inventoryLocation:
        propertyPageData?.data?.region?.name ||
        propertyPageData?.data?.region?.city ||
        propertyPageData?.data?.region?.combined_name ||
        t("this location"),
      inventoryPricingDuration: propertyPageData?.data?.pricing?.duration,
    }),
    shallowEqual,
  );

  const currencySymbol = getPricingCurrency(inventoryCurrency) || "£";
  const pricingPeriod = getPricingDuration(inventoryPricingDuration) || t("week");

  const formatTotalPrice = (price: number) => {
    const numPrice = Number(price);
    const roundedPrice = Math.round(numPrice);
    const isRounded = numPrice !== roundedPrice;
    return { price: roundedPrice, isRounded };
  };

  const { price: totalPrice, isRounded } = formatTotalPrice(totalCalculatedPrice);
  const tilde = isRounded ? "~" : "";

  const formattedTotalPrice = hasEstimatedItems
    ? `${tilde}${currencySymbol}${totalPrice}+/${pricingPeriod}`
    : `${tilde}${currencySymbol}${totalPrice}/${pricingPeriod}`;

  const renderModalLayout = () => (
    <>
      {filteredData.length > 0 && (
        <div className={formatClassNames(styles.amenitiesContainerOuter, styles.modalMobileBills)}>
          <div className={styles.amenitiesContainerInner}>
            {filteredData?.map((feature: any, idx: number) => (
              <AmenitySection
                dataTestId="property-amentities"
                title={feature?.name}
                amenityList={feature?.values}
                withDivider={idx < filteredData?.length - 1}
                key={feature?.name}
                isDesktop={false}
                amenitiesImages={[]}
              />
            ))}
          </div>
        </div>
      )}
      <div className={styles.margintop4px} />
      {(hasInstallmentPlans || config.IS_CHINA_APP) && (
        <div className={formatClassNames(styles.amenitiesContainerOuter, styles.modalMobileBills)}>
          <div className={styles.amenitiesContainerInner}>
            <div className={formatClassNames(styles.amenitiesSubTitle)}>
              {t("propertypage.instalmentsection.instalmentplanstring")}
            </div>
            <div className={styles.divider} />

            <div className={formatClassNames(styles.amenitiesSubTitle)}>
              <InstalmentFilterGroup
                filtersData={filtersData}
                setDuration={(duration) => setSelectedDuration(duration)}
                setYear={(year) => setSelectedYear(year)}
              />
            </div>
            <div className={styles.divider} />

            <TabSection
              tabdata={tabdata}
              setActiveTab={setActiveTab}
              activeTab={activeTab}
              isDesktop={isDesktop}
            />
          </div>
        </div>
      )}
      <div className={styles.margintop4px} />
      {(hasInstallmentPlans || config.IS_CHINA_APP) && (
        <>
          <AccordionV2
            data={getInstallmentPlansByGuarantorType(
              installmentPlans,
              selectedDuration,
              selectedYear,
              activeTab,
              t,
            )}
            CustomAccordionItem={CustomAccordionItem}
            isDesktop={false}
            sectionClassname={formatClassNames(styles.sectionV2, styles.sectionV2Modal)}
          />

          <div className={styles.accordionWrapperMobileModal}>
            <div className={styles.noteContainer}>
              <span className={styles.noteLabel}>
                {t("propertypage.instalmentsection.notestring")}:{" "}
              </span>
              <span className={styles.noteText}>
                {t("propertypage.instalmentsection.illustrationnotestring")}
              </span>
            </div>
          </div>
        </>
      )}
      <div className={styles.margintop4px} />
      <CustomModeOfPayment isModal={isModal} isDesktop={isDesktop} />
    </>
  );

  if (isModal) return renderModalLayout();
  return (
    <>
      <div className={styles.amenitiesContainerInner}>
        {filteredData?.map((feature: any, idx: number) => (
          <>
            {!(
              feature?.name === "Bills Included" &&
              (!feature?.values || feature?.values?.length === 0)
            ) && (
              <AmenitySection
                dataTestId="property-amentities"
                title={feature.name}
                amenityList={feature?.values}
                withDivider={idx < filteredData?.length - 1}
                key={feature.name}
                isDesktop
                amenitiesImages={[]}
              />
            )}
          </>
        ))}
        {!allAmenitiesHaveNAPrices && (
          <>
            <div className={styles.totalSection}>
              <div className={styles.totalLabel}>
                {t("propertypage.instalmentsection.estimatedsavingsstringhalf")}
                {inventoryLocation})
              </div>
              <div className={styles.totalAmount}>
                <span className={styles.totalPrice}>{formattedTotalPrice}</span>
                <span className={styles.freeTag}>{t("propertypage.instalmentsection.free")}</span>
              </div>
            </div>
            <div className={styles.divider} />
            <Button
              dataTestId="property-view-all-amenities"
              variant="showAll"
              onClick={handleBillsModalOpen}
            >
              {t("propertypage.instalmentsection.viewsavingsbreakdownstring")}
            </Button>
          </>
        )}
        {/* <Seprator noMargin /> */}

        {showBillsModal && (
          <PropertyDetailsModal
            header={t("propertypage.instalmentsection.billsincludedstring")}
            actionButtonText={t("propertypage.instalmentsection.gotitstring")}
            hidePropertyModal={handleBillsModalClose}
            isDesktop={isDesktop}
          >
            {prefixContent && <>{prefixContent}</>}
            <>
              <BillsIncludedModal
                amenities={amenities.length > 0 ? amenities : []}
                totalWeeklyCost={totalCalculatedPrice || 80}
                isDesktop={isDesktop}
              />
            </>
            {suffixContent && <>{suffixContent}</>}
          </PropertyDetailsModal>
        )}

        {(hasInstallmentPlans || config.IS_CHINA_APP) && (
          <>
            <div className={styles.divider} />
            <div className={formatClassNames(styles.amenitiesSubTitle)} id="rent_instalments">
              {t("propertypage.instalmentsection.instalmentplanstring")}
            </div>
            <div className={styles.divider} />

            <div className={formatClassNames(styles.amenitiesSubTitle)}>
              <InstalmentFilterGroup
                filtersData={filtersData}
                setDuration={(duration) => setSelectedDuration(duration)}
                setYear={(year) => setSelectedYear(year)}
              />
            </div>
            <div className={styles.divider} />

            <TabSection
              tabdata={tabdata}
              setActiveTab={setActiveTab}
              activeTab={activeTab}
              isDesktop={isDesktop}
            />
            <div className={styles.divider} />
          </>
        )}
      </div>
      {/* </div> */}

      {(hasInstallmentPlans || config.IS_CHINA_APP) && (
        <>
          <AccordionV2
            data={getInstallmentPlansByGuarantorType(
              installmentPlans,
              selectedDuration,
              selectedYear,
              activeTab,
              t,
            )}
            CustomAccordionItem={CustomAccordionItem}
            isDesktop={false}
            sectionClassname={formatClassNames(styles.sectionV2)}
          />

          <div className={styles.accordionWrapperMobile}>
            <div className={styles.noteContainer}>
              <span className={styles.noteLabel}>
                {t("propertypage.instalmentsection.notestring")} :{" "}
              </span>
              <span className={styles.noteText}>
                {t("propertypage.instalmentsection.illustrationnotestring")}
              </span>
            </div>
          </div>
        </>
      )}

      <CustomModeOfPayment isModal={isModal} isDesktop={isDesktop} />

      {showModal && (
        <PropertyDetailsModal
          header={t("propertypage.instalmentsection.amenitiesstring")}
          hidePropertyModal={handleModalClose}
          isDesktop={false}
          bodyWithNoPadding
        >
          <div className={styles.amenitiesContainerOuter}>
            <div className={styles.amenitiesContainerInner}>
              {sortedData?.map((feature: any, idx: number) => (
                <AmenitySection
                  dataTestId="property-amentities-modal"
                  title={feature?.name}
                  amenityList={feature?.values}
                  withDivider={idx < sortedData?.length - 1}
                  isDesktop={false}
                  amenitiesImages={[]}
                  modalView
                  showAll
                />
              ))}
            </div>
          </div>
        </PropertyDetailsModal>
      )}
    </>
  );
};

export default wrapperHOC(MobileInstalmentSection, {
  componentName: "MobileInstalmentSection-InstalmentSection-PropertyPage",
  showForChina: true,
});
